import axios from 'axios';

// 存储令牌信息
let tokenCache = {
  access_token: null,
  token_type: null,
  expires_in: 0,
  expiresTime: 0
};

// 获取OAuth令牌
const getTokenFromServer = async (axiosInstance, url, clientId, clientSecret, scope) => {
  try {
    const params = new URLSearchParams();
    params.append('grant_type', 'client_credentials');
    params.append('client_id', clientId);
    params.append('client_secret', clientSecret);
    
    if (scope) {
      params.append('scope', scope);
    }
    
    console.log('OAuth请求参数:', {
      url,
      clientId,
      clientSecret,
      scope
    });
    
    const response = await axiosInstance.post(url, params, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });
    
    return response.data;
  } catch (error) {
    console.error('获取OAuth令牌失败:', error);
    if (error.response) {
      // 服务器响应了错误状态码
      console.error('服务器响应:', error.response.status, error.response.data);
    } else if (error.request) {
      // 请求已发送但没有收到响应
      console.error('没有收到响应，请检查网络和服务器状态');
    } else {
      // 设置请求时发生错误
      console.error('请求配置错误:', error.message);
    }
    return null;
  }
};

// 主要函数：获取令牌并缓存
export const getAuthorizationToken = async (config) => {
  const now = new Date().getTime();
  
  // 如果有缓存的令牌且未过期，直接返回
  if (tokenCache.access_token && tokenCache.expiresTime > now) {
    return `${tokenCache.token_type} ${tokenCache.access_token}`;
  }
  
  const axiosInstance = axios.create({
    baseURL: process.env.VUE_APP_BASE_API,
    timeout: 30000, // 增加超时时间到30秒
    httpsAgent: new (require('https').Agent)({
      rejectUnauthorized: false // 禁用SSL证书验证，仅用于开发环境
    })
  });
  
  console.log('OAuth配置:', {
    baseURL: process.env.VUE_APP_BASE_API,
    tokenUrl: config.access_token_url
  });
  
  // 获取新令牌
  const data = await getTokenFromServer(
    axiosInstance,
    config.access_token_url,
    config.clientId,
    config.clientSecret,
    config.scope
  );
  
  if (!data || !data.access_token) {
    console.error('无法获取OAuth令牌，请检查配置和服务器状态');
    return null;
  }
  
  // 缓存令牌信息
  tokenCache = {
    access_token: data.access_token,
    token_type: data.token_type,
    expires_in: data.expires_in,
    expiresTime: now + (data.expires_in * 1000)
  };
  
  return `${data.token_type} ${data.access_token}`;
};

export default {
  getAuthorizationToken
}; 